const MAX_ENTRIES = 150;
const _buffer = [];

function safeSerialize(val) {
  if (val === null) return 'null';
  if (val === undefined) return 'undefined';
  if (typeof val === 'string') return val;
  if (val instanceof Error) return `${val.name}: ${val.message}`;
  try { return JSON.stringify(val); } catch { return String(val); }
}

function patch(level) {
  const orig = console[level];
  console[level] = (...args) => {
    _buffer.push({ level, time: new Date().toISOString(), message: args.map(safeSerialize).join(' ') });
    if (_buffer.length > MAX_ENTRIES) _buffer.shift();
    orig.apply(console, args);
  };
}

['log', 'warn', 'error'].forEach(patch);

export function getRecentLogs() {
  return [..._buffer];
}
